import UserService from "projects/api/UserService";

const GET_USER_BY_INVITE = "GET_USER_BY_INVITE";
const GET_CURRENT_USER = "GET_CURRENT_USER";
const GET_USER_BY_INVITE_ERROR = "GET_USER_BY_INVITE_ERROR";

export const getUserByInvite = (inviteToken) => async (dispatch) => {
  try {
    const response = await UserService.getUserByInvite(inviteToken);

    dispatch({
      type: GET_USER_BY_INVITE,
      response: response?.data?.data, // Assuming response.data is the user info
    });

    return response.data;
  } catch (error) {
    // Only extract serializable parts of the error
    const serializableError = {
      message: error?.message || "Unknown error",
      status: error?.response?.status,
      data: error?.response?.data || {},
      fieldErrors: error?.fieldErrors || null,
    };

    dispatch({
      type: GET_USER_BY_INVITE_ERROR,
      error: serializableError, // Only store serializable data
    });

    return error.response?.data || {};
  }
};

export const getCurrentUserInfo = () => ({
  type: GET_CURRENT_USER,
  apiCall: () => UserService.getCurrentUserInfo(),
});

const initialState = {
  userByInvite: {},
  userInfo: {},
};

export default (state = initialState, action) => {
  const { response } = action;

  switch (action.type) {
    case GET_USER_BY_INVITE: {
      return {
        ...state,
        userByInvite: {
          ...state.userByInvite,
          ...action.response,
          error: null, // Clear any previous errors
        },
      };
    }
    case GET_USER_BY_INVITE_ERROR: {
      return {
        ...state,
        userByInvite: {
          ...state.userByInvite,
          error: action.error, // New immutable error object
        },
      };
    }
    case GET_CURRENT_USER: {
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...response,
        },
      };
    }
    default:
      return state;
  }
};
